module.exports = __webpack_public_path__ + "static/media/about2.82bbb42c.jpg";